import React from "react";
import { Box, Typography, Paper, Grid } from "@material-ui/core";

export const BoxDetails = ({ translate, classes, selectedBox }) => {
	if (!selectedBox) {
		return <Typography>{translate("tab.pallets.boxes.no_box_selected")}</Typography>;
	}

	return (
		<Box>
			<Typography variant="h5" className={classes.sectionTitle}>
				{translate("tab.pallets.box_information")}
			</Typography>

			<Grid container spacing={3}>
				<Grid item xs={12} md={6}>
					<Paper className={classes.infoCard}>
						<Typography variant="h6" gutterBottom color="primary">
							{translate("tab.pallets.box_details")}
						</Typography>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>{translate("tab.pallets.sscc")}:</Typography>
							<Typography className={classes.infoValue}>{selectedBox.sscc || "N/A"}</Typography>
						</Box>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>{translate("tab.pallets.net_weight")}:</Typography>
							<Typography className={classes.infoValue}>
								{selectedBox.net_weight != null
									? `${selectedBox.net_weight} ${selectedBox.weight_unit_code || ""}`
									: "N/A"}
							</Typography>
						</Box>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>{translate("tab.pallets.weight_unit_code")}:</Typography>
							<Typography className={classes.infoValue}>
								{selectedBox.weight_unit_code || "N/A"}
							</Typography>
						</Box>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>{translate("tab.pallets.external_id")}:</Typography>
							<Typography className={classes.infoValue}>{selectedBox.ext_id || "N/A"}</Typography>
						</Box>
					</Paper>
				</Grid>

				<Grid item xs={12} md={6}>
					<Paper className={classes.infoCard}>
						<Typography variant="h6" gutterBottom color="primary">
							{translate("tab.pallets.product_information")}
						</Typography>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>{translate("tab.pallets.product_code")}:</Typography>
							<Typography className={classes.infoValue}>
								{selectedBox.ext_product_code || "N/A"}
							</Typography>
						</Box>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>{translate("tab.pallets.boxes.description")}:</Typography>
							<Typography className={classes.infoValue}>
								{selectedBox.ext_product_description || "N/A"}
							</Typography>
						</Box>
					</Paper>
				</Grid>

				{/* Product Attributes and Box Attributes side by side */}
				{selectedBox.ext_product_attributes && (
					<Grid item xs={12} md={6}>
						<Paper className={classes.infoCard}>
							<Typography variant="h6" gutterBottom color="primary">
								{translate("tab.pallets.product_attributes")}
							</Typography>
							{Object.entries(selectedBox.ext_product_attributes).map(([key, value]) => (
								<Box key={key} className={classes.infoRow}>
									<Typography className={classes.infoLabel}>
										{key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}:
									</Typography>
									<Typography className={classes.infoValue}>{String(value)}</Typography>
								</Box>
							))}
						</Paper>
					</Grid>
				)}

				{selectedBox.ext_box_attributes && (
					<Grid item xs={12} md={6}>
						<Paper className={classes.infoCard}>
							<Typography variant="h6" gutterBottom color="primary">
								{translate("tab.pallets.box_attributes")}
							</Typography>
							{Object.entries(selectedBox.ext_box_attributes).map(([key, value]) => (
								<Box key={key} className={classes.infoRow}>
									<Typography className={classes.infoLabel}>
										{key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}:
									</Typography>
									<Typography className={classes.infoValue}>{String(value)}</Typography>
								</Box>
							))}
						</Paper>
					</Grid>
				)}
			</Grid>
		</Box>
	);
};